import React from 'react'
import SbEditable from 'storyblok-react'

const DidYouKnowBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="did-you-know-block">
        <div className="did-you-know-block-container">
          <div className="did-you-know-block-container-inner">
            <div className="did-you-know-block-icon">
              <i class="fal fa-lightbulb-on"></i>
            </div>
            <div className="did-you-know-block-text">
              <div className="did-you-know-block-intro">{block.intro}</div>
              <div className="did-you-know-block-fact">{block.text}</div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default DidYouKnowBlock
